<script lang="ts" setup></script>

<template>
  <div class="city-select__spinner" />
</template>

<style lang="scss" scoped>
.city-select {
  &__spinner {
    width: 24px;
    height: 24px;
    border: 2px solid #e5e7eb;
    border-top-color: #111827;
    border-radius: 50%;
    animation: city-spinner 0.7s linear infinite;
  }
}

@keyframes city-spinner {
  to {
    transform: rotate(360deg);
  }
}
</style>
